export enum SlideType {
  CAROUSEL = 'carousel',
  CARDS = 'cards'
}

export enum SocialNetworkEnum {
  TWITTER,
  FACEBOOK,
  LINKEDIN,
  INSTAGRAM,
}

export enum SocialIconPathEnum {
  TWITTER = '/assets/images/icons/social/icon-social-twitter-primary-filled.svg',
  FACEBOOK = '/assets/images/icons/social/icon-social-facebook-primary-filled.svg',
  LINKEDIN = '/assets/images/icons/social/icon-social-linkedin-primary-filled.svg',
  INSTAGRAM = '/assets/images/icons/social/icon-social-instagram-primary-filled.svg',
}

export enum SocialShareBaseUrlEnum {
  TWITTER = 'https://twitter.com/share?url=',
  FACEBOOK = 'https://www.facebook.com/sharer/sharer.php?u=',
  LINKEDIN = 'https://www.linkedin.com/shareArticle?mini=true&url=',
  INSTAGRAM = 'https://www.instagram.com/share/?url=',
}

export enum SubTypeEnum {
  HOME_PAGE = -1,
  TOPIC = 0,
  REQUEST = 1,
  DASHBOARD = 2,
  RequestCatalog = 3,
  IFRAME = 4,
  WEB_LINK = 5,
  NAV_GROUP = 6,
  NAVIGATION_TAB = 7,
  TILDA = 8,
  FEEDS = 9,
  LIBRARY = 10,
  REQUESTS = 11,
  ACTIVITIES = 12,
  SCORE_CARD = 13
}

export enum TabCastTypeEnum {
  TOPIC,
  REQUEST,
  DASHBOARD,
  RequestCatalog,
  IFRAME,
  TILDA,
  FEEDS,
  BLOG,
  LIBRARY
}

export enum SnackbarType {
  Success = 'SUCCESS',
  Error = 'ERROR',
  Warn = 'WARN',
  Dark = 'DARK'
}

export enum WebMenuEnum {
  SIGN_IN = '1',
  SIGN_UP = '2',
  SIGN_IN_UP = '3',
  PROFILE = '4',
}

export enum OtpMethod {
  WhatsApp = 'whatsapp',
  SMS = 'sms',
}

export enum AdminRole {
  FullControl = 'FullControl',
  ContentCreator = 'ContentCreator'
}

export enum EspClockType {
  ClockIn = 'Clock In',
  ClockOut = 'Clock Out',
  ClockedOut = 'Clocked Out'
}

export enum EspClockStatus {
  NoClockIn = "NoClockIn",
  ClockedIn = 'ClockedIn',
  ClockedOut = 'ClockedOut',
  WorkEnd = 'WorkEnd'
}
export enum attendanceStatus {
  singleClockIn = "singleClockIn",
  isIPBlocked = 'isIPBlocked',
  isWeekend = 'isWeekend',
  lateArrival = 'lateArrival',
  clockIn = 'clockIn',
  clockOut = 'clockOut',
  cutOffTime = 'cutOffTime'
}

export enum SlideActionButtonEnum {
  WhiteStrokeWhiteText = 'ws-wt-btn',
  PrimaryStrokePrimaryText = 'ps-pt-btn',
  GreyStrokePrimaryText = 'gs-pt-btn',
  WhiteButtonPrimaryText = 'wb-pt-btn',
  PrimaryButtonWhiteText = 'pb-wt-btn',
}

export enum SubGroupType {
  UserType = 'UserType',
  SubTenant = 'SubTenant'
}

export enum QueryFieldType {
  Text = 'text',
  Date = 'date'
}

export enum NotificationChannelType {
  Sms = 'Sms',
  Email = 'Email'
}